import React from 'react';
import { cssMap } from '@atlaskit/css';
import { Grid } from '@atlaskit/primitives/compiled';
import CompassRepositoryCard from '../compass-repository-card/index.tsx';
import type { Repository } from '../types.tsx';

const gridStyles = cssMap({
	root: {
		gridTemplateColumns: '1fr 1fr',
	},
});

export interface ConnectedRepositoryListProps {
	filteredRepositories: Repository[];
}

export const ConnectedRepositoryList: React.FC<ConnectedRepositoryListProps> = ({
	filteredRepositories,
}) => {
	if (!filteredRepositories.length) {
		return null;
	}

	return (
		<Grid gap="space.300" alignItems="center" xcss={gridStyles.root}>
			{filteredRepositories.slice(0, 6).map((repo, idx) => (
				<CompassRepositoryCard
					key={repo.name}
					repositoryName={repo.name}
					cardVisualConfigurationIndex={idx}
				/>
			))}
		</Grid>
	);
};
